import { AgColDefsI, AgGridI, paginationModel } from "../../../shared/common-components/ag-grid/ag-grid.model";
import { CustomExpandableComponent } from "../../../shared/common-components/ag-grid/custom-expandable/custom-expandable.component";
import { CustomHeaderComponent } from "../../../shared/common-components/ag-grid/custom-header/custom-header.component";
import { EditDeleteIconComponent } from "../../../shared/common-components/ag-grid/edit-delete-icon/edit-delete-icon.component";
import { TextRendererComponent } from "../../../shared/common-components/ag-grid/text-renderer/text-renderer.component";
import { AmountColWidth, StorageName, VoucherColWidth, WeightColWidth,NameColWidth } from "../../enum/common-enum";
import { AgGridCustomInputComponent } from "../ag-grid/ag-grid-custom-input/ag-grid-custom-input.component";
import { DateCellRendererComponent } from "../ag-grid/date-cell-renderer/date-cell-renderer.component";
import { NumericCellRendererComponent } from "../ag-grid/numeric-cell-renderer/numeric-cell-renderer.component";
export class GetAllPaymentList extends paginationModel{
  pageSize      : number = 25;
  branchId      : number;
  voucherTypeId : number;
  ledgerId      : number;
  productId     : number;
  exportAs      :number;
  exportRequest : exportRequest[];
}

export class exportRequest {
  gridName : string;
  columnToInclude : any
}

const ExpandableColumn: AgColDefsI = 
{
  headerName: "",
  field: "isExpandable",
  lockPosition: "left",
  headerComponent: CustomHeaderComponent,
  headerClass:"px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start",
  lockPinned: true,
  suppressMovable: false,
  wrapText: true,
  autoHeight: true,
  resizable: false,
  cellClass: "custom-column-group-cell text-end ",
  minWidth: 0,
  maxWidth: 0,
  flex: 0,
  cellStyle: {
    position: "relative",
    top: "0px",
    minWidth: "100%",
    // innerHeight:"380px",
    // left: "0 !important",
  },
  cellClassRules: {"borders-0": (params) => !params?.data?.isExpandable ?? false, },
  cellRenderer: CustomExpandableComponent,
  cellRendererParams: { context: this },
  width: 0,
}

const SRNOColumn: AgColDefsI = 
{
  headerName: "Sr.No.",
  headerComponent: CustomHeaderComponent,
  sortable: true,
  headerClass:"px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start",
  field: "srNo",
  cellClass: "custom-column-group-cell text-end",
  minWidth: 80,
  maxWidth: 80,
  flex: 1,
  editable:false,
  //  cellRenderer: (params) => `<span> ${params.rowIndex + 1}<span>`,
  cellRenderer: TextRendererComponent,
  lockPinned: true,
  lockPosition: 'left',
  suppressMovable:false,
}
const LedgerNameColumn: AgColDefsI = 
{
  headerName: "Ledger Name",
  headerComponent: CustomHeaderComponent,
  sortable: true,
  headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start",
  field: "ledgerName",
  cellClass: "custom-column-group-cell px-0",
  flex: 3,
  cellRenderer: TextRendererComponent,
  lockPinned: true,
  lockPosition: 'left',
  suppressMovable:false,
  editable:false
}
const SalesPersonColumn: AgColDefsI = 
{
  headerName: "Sales Person",
  headerComponent: CustomHeaderComponent,
  sortable: true,
  headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start",
  field: "salePersonName",
  cellClass: "custom-column-group-cell px-0",
  maxWidth:NameColWidth.MaxWidth,
  minWidth:NameColWidth.MinWidth,
  flex: 3,
  cellRenderer: TextRendererComponent,
  lockPinned: true,
  lockPosition: 'left',
  suppressMovable:false,
  editable:false
}
const DateColumn: AgColDefsI = 
{
  headerName: "Date",
  headerComponent: CustomHeaderComponent,
  sortable: true,
  headerClass:"px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold justify_content_start ag_header_end",
  field: "date",
  cellClass: "px-1 custom-column-group-cell text-end",
  flex: 1,
  editable:false,
  cellRenderer:DateCellRendererComponent,
}
const InvoiceNoColumn: AgColDefsI = {
  headerName: "Invoice No.",
  headerComponent: CustomHeaderComponent,
  sortable: true,
  minWidth:AmountColWidth.MinWidth,
  maxWidth:AmountColWidth.MaxWidth,
  editable:false,
  headerClass:
    "px-0 custom-column-group-cell",
  field: "invoiceNo",
  cellClass:'px-0 custom-column-group-cell',
  flex: 2,
  cellRenderer: TextRendererComponent,
};

const BranchName: AgColDefsI = { 
  headerName: "Branch Name", 
  headerComponentParams: {enableMenu:false},
  sortable:true,
  headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
  field: 'branchName',
  cellClass:'px-0 custom-column-group-cell',
  suppressMovable: false,
  resizable: true, 
  cellRenderer: TextRendererComponent,
  editable:false, 
  minWidth: 180, flex:2,
}
const ActionColumn: AgColDefsI = 
{
  headerName: "",
  field:'',
  cellRenderer: EditDeleteIconComponent,
  cellClass: " custom-column-group-cell d-flex align-items-center justify-content-center",
  headerClass:
    "justify-content-center px-0 custom-column-group-cell border-0",
  minWidth: 80,
  maxWidth: 80,
  editable:false,
  headerComponentParams: {deleteThroughApi : true},
  flex: 1,
  lockPinned: true,
  lockPosition: 'right',
  suppressMovable:false,
  cellRendererParams: (params)=>{
      switch(params?.api?.voucherType)
          {
            case 'ReceiptVoucher':
              return{
                editIcon : true,
                hasViewPermission: params?.api?.permission?.receiptVoucherCanUpdate,
                hasDeletePermission : params?.api?.permission?.receiptVoucherCanDelete,
              } 
            case 'PaymentVoucher':
             return {
                editIcon : true,
                hasViewPermission: params?.api?.permission?.paymentVoucherCanUpdate,
                hasDeletePermission : params?.api?.permission?.paymentVoucherCanDelete,
             }
            case 'MaterialIn':
             return {
                editIcon : true,
                hasViewPermission: params?.api?.permission?.materialInCanUpdate,
                hasDeletePermission : params?.api?.permission?.materialInCanDelete,
              }
            case 'MaterialOut':
             return {
              editIcon : true,
                hasViewPermission: params?.api?.permission?.materialOutCanUpdate,
                hasDeletePermission : params?.api?.permission?.materialOutCanDelete,
             }
             case 'Expense':
              return {
               editIcon : true,
                 hasViewPermission: params?.api?.permission?.expensesCanUpdate,
                 hasDeletePermission : params?.api?.permission?.expensesCanDelete,
              }
              case 'income':
                return {
                 editIcon : true,
                   hasViewPermission: params?.api?.permission?.incomeCanUpdate,
                   hasDeletePermission : params?.api?.permission?.incomeCanDelete,
                }
        }
  },
}
const VoucherTypeColumn: AgColDefsI = {
  headerName: "Against Voucher Type",
  headerClass: "px-0 custom-column-group-cell", 
  field: 'againstVoucherType',
  cellClass:'px-0 font-regular custom-column-group-cell', 
  minWidth: VoucherColWidth.MinWidth,
  maxWidth: VoucherColWidth.MaxWidth, 
  sortable: true,
  resizable:true,
  editable:false,
  cellRenderer: TextRendererComponent,
};
export const AgainstColumn: AgColDefsI = {
  headerName: "Against Voucher No.",
  field: "againstInvoiceNo",
  minWidth: 110,
  headerClass: "custom-column-group-cell px-0",
  cellClass: "custom-column-group-cell cursorPointer",
  editable: false,
  sortable: true,
  cellRenderer: TextRendererComponent
};
const TotalAmountColumn: AgColDefsI = {
  headerName: "Total Amount",
  field: "totalAmount",
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  headerClass: "custom-column-group-cell px-0 ag_header_end ",
  cellClass: "custom-column-group-cell px-0 text-end",
  editable: false,
  sortable: true,
  resizable: true,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isAmt: true },
}
const TotalWeightColumn: AgColDefsI = {
  headerName: "Total Weight",
  field: "totalWt",
  minWidth: WeightColWidth.MinWidth,
  maxWidth: WeightColWidth.MaxWidth,
  headerClass: "custom-column-group-cell px-0 ag_header_end",
  cellClass: "custom-column-group-cell px-0 text-end",
  editable: false,
  sortable: true,
  resizable: true,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isWeight: true },
}
export const CashColumn: AgColDefsI = {
  headerName: "Cash",
  headerComponent: CustomHeaderComponent,
  headerClass:"custom-column-group-cell px-0 ag_header_end",
  field: "cash",
  sortable: true,
  cellClass: "custom-column-group-cell px-0 text-end",
  headerComponentParams: { enableSorting: true },
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  flex: 1,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomInputComponent,
  cellEditorParams: {
    decimalPlaces: 3,
    isOnlyNumbers: true,
    inputMaxlength: 8
  },
};
export const BankColumn: AgColDefsI = {
  headerName: "Bank",
  headerComponent: CustomHeaderComponent,
  headerClass:"custom-column-group-cell px-0 ag_header_end",
  field: "bank",
  sortable: true,
  cellClass: "custom-column-group-cell px-0 text-end",
  headerComponentParams: { enableSorting: true },
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  flex: 1,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomInputComponent,
  cellEditorParams: {
    decimalPlaces: 3,
    isOnlyNumbers: true,
    inputMaxlength: 8
  },
};
export const ChequeColumn: AgColDefsI = {
  headerName: "Cheque",
  headerComponent: CustomHeaderComponent,
  headerClass:"custom-column-group-cell px-0 ag_header_end",
  field: "cheque",
  sortable: true,
  cellClass: "custom-column-group-cell px-0 text-end",
  headerComponentParams: { enableSorting: true },
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  flex: 1,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomInputComponent,
  cellEditorParams: {
    decimalPlaces: 3,
    isOnlyNumbers: true,
    inputMaxlength: 8
  },
};
export const UPIColumn: AgColDefsI = {
  headerName: "UPI",
  headerComponent: CustomHeaderComponent,
  headerClass:"custom-column-group-cell px-0 ag_header_end",
  field: "upi",
  sortable: true,
  cellClass: "custom-column-group-cell px-0 text-end",
  headerComponentParams: { enableSorting: true },
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  flex: 1,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomInputComponent,
  cellEditorParams: {
    decimalPlaces: 3,
    isOnlyNumbers: true,
    inputMaxlength: 8
  },
};
export const CardColumn: AgColDefsI = {
  headerName: "Card",
  headerComponent: CustomHeaderComponent,
  headerClass:"custom-column-group-cell px-0 ag_header_end",
  field: "card",
  sortable: true,
  cellClass: "custom-column-group-cell px-0 text-end",
  headerComponentParams: { enableSorting: true },
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  flex: 1,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomInputComponent,
  cellEditorParams: {
    decimalPlaces: 3,
    isOnlyNumbers: true,
    inputMaxlength: 8
  },
};
export const MetalExchangeAmountColumn: AgColDefsI = {
  headerName: "Metal Exchange Amount",
  headerComponent: CustomHeaderComponent,
  headerClass:"custom-column-group-cell px-0 ag_header_end",
  field: "metalExchangeAmount",
  sortable: true,
  cellClass: "custom-column-group-cell px-0 text-end",
  headerComponentParams: { enableSorting: true },
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  flex: 1,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomInputComponent,
  cellEditorParams: {
    decimalPlaces: 3,
    isOnlyNumbers: true,
    inputMaxlength: 8
  },
};
export const OldJewellryAmountColumn: AgColDefsI = {
  headerName: "Old Jewellry Amount",
  headerComponent: CustomHeaderComponent,
  headerClass:"custom-column-group-cell px-0 ag_header_end",
  field: "oldJewellryAmount",
  sortable: true,
  cellClass: "custom-column-group-cell px-0 text-end",
  headerComponentParams: { enableSorting: true },
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  flex: 1,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomInputComponent,
  cellEditorParams: {
    decimalPlaces: 3,
    isOnlyNumbers: true,
    inputMaxlength: 8
  },
};
export const MetalExchangeWtColumn: AgColDefsI = {
  headerName: "Metal Exchange Wt.",
  headerComponent: CustomHeaderComponent,
  headerClass:"custom-column-group-cell px-0 ag_header_end",
  field: "metalExchangeWt",
  sortable: true,
  cellClass: "custom-column-group-cell px-0 text-end",
  headerComponentParams: { enableSorting: true },
  minWidth: WeightColWidth.MinWidth,
  maxWidth: WeightColWidth.MaxWidth,
  flex: 1,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomInputComponent,
  cellEditorParams: {
    decimalPlaces: 3,
    isOnlyNumbers: true,
    inputMaxlength: 8
  },
};
export const OldJewellryWtColumn: AgColDefsI = {
  headerName: "Old Jewellry Wt.",
  headerComponent: CustomHeaderComponent,
  headerClass:"custom-column-group-cell px-0 ag_header_end",
  field: "oldJewellryWt",
  sortable: true,
  cellClass: "custom-column-group-cell px-0 text-end",
  headerComponentParams: { enableSorting: true },
  minWidth: WeightColWidth.MinWidth,
  maxWidth: WeightColWidth.MaxWidth,
  flex: 1,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomInputComponent,
  cellEditorParams: {
    decimalPlaces: 3,
    isOnlyNumbers: true,
    inputMaxlength: 8
  },
};
export const M2AColumn: AgColDefsI = {
  headerName: "M2A",
  headerComponent: CustomHeaderComponent,
  headerClass:"custom-column-group-cell px-0 ag_header_end",
  field: "m2A",
  sortable: true,
  cellClass: "custom-column-group-cell px-0 text-end",
  headerComponentParams: { enableSorting: true },
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  flex: 1,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomInputComponent,
  cellEditorParams: {
    decimalPlaces: 3,
    isOnlyNumbers: true,
    inputMaxlength: 8
  },
};
export const A2MColumn: AgColDefsI = {
  headerName: "A2M",
  headerComponent: CustomHeaderComponent,
  headerClass:"custom-column-group-cell px-0 ag_header_end",
  field: "a2M",
  sortable: true,
  cellClass: "custom-column-group-cell px-0 text-end",
  headerComponentParams: { enableSorting: true },
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  flex: 1,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomInputComponent,
  cellEditorParams: {
    decimalPlaces: 3,
    isOnlyNumbers: true,
    inputMaxlength: 8
  },
};
export const CurrencyColumn: AgColDefsI = {
  headerName: "Currency",
  field: "currency",
  minWidth: 110,
  headerClass: "custom-column-group-cell px-0",
  cellClass: "custom-column-group-cell",
  editable: false,
  sortable: true,
  cellRenderer: TextRendererComponent
};
export const ExpansesWithTaxColumn: AgColDefsI = {
  headerName: "Expenses With Tax",
  field: "expensesWithTax",
  minWidth: 110,
  headerClass: "custom-column-group-cell px-0",
  cellClass: "custom-column-group-cell",
  editable: false,
  sortable: true,
  cellRenderer: TextRendererComponent
};
const PaidAmount: AgColDefsI = {
  headerName: "Paid Amt.",
  field: "amountPaid",
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  headerClass: "custom-column-group-cell px-0 ag_header_end ",
  cellClass: "custom-column-group-cell px-0 text-end",
  editable: false,
  sortable: true,
  resizable: true,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isAmt: true },
}
const TotalAmount: AgColDefsI = {
  headerName: "Total Amt.",
  field: "totalAmount",
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  headerClass: "custom-column-group-cell px-0 ag_header_end ",
  cellClass: "custom-column-group-cell px-0 text-end",
  editable: false,
  sortable: true,
  resizable: true,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isAmt: true },
}
export const ColDefsPaymentVoucherList: AgColDefsI[] = 
[
  // ExpandableColumn,
  SRNOColumn,
  DateColumn,
  LedgerNameColumn,
  SalesPersonColumn,
  InvoiceNoColumn,
  BranchName,
  VoucherTypeColumn,
  AgainstColumn,
  TotalAmountColumn,
  TotalWeightColumn,
  CashColumn,
  BankColumn,
  ChequeColumn,
  UPIColumn,
  CardColumn,
  MetalExchangeAmountColumn,
  OldJewellryAmountColumn,
  MetalExchangeWtColumn,
  OldJewellryWtColumn,
  M2AColumn,
  A2MColumn,
  ActionColumn,
]
export const ColDefsPayment: AgColDefsI[] = 
[
  SRNOColumn,
  DateColumn,
  LedgerNameColumn,
  InvoiceNoColumn,
  ActionColumn,
  CurrencyColumn,
  ExpansesWithTaxColumn,
  PaidAmount,
  TotalAmount
]


export class PaymentListSectionModel {
  storageName: string;

  setVisibility(storageName: any) {
    switch (storageName) {
      case StorageName.FORMNAME_TRANSACTION_RECEIPTVOUCHER:
        this.storageName = StorageName.TRANSACTION_RECEIPTVOUCHER_PAYMENTLIST_GRID;
        break;
      case StorageName.FORMNAME_TRANSACTION_PAYMENTVOUCHER:
        this.storageName = StorageName.TRANSACTION_PAYMENTVOUCHER_PAYMENTLIST_GRID;
        break;
      case StorageName.FORMNAME_TRANSACTION_MATERIALIN:
        this.storageName = StorageName.TRANSACTION_MATERIALIN_PAYMENTLIST_GRID;
        break;
      case StorageName.FORMNAME_TRANSACTION_MATERIALOUT:
        this.storageName = StorageName.TRANSACTION_MATERIALOUT_PAYMENTLIST_GRID;
        break;
      case StorageName.FORMNAME_TRANSACTION_EXPENSES:
        this.storageName = StorageName.TRANSACTION_EXPENSES_PAYMENTLIST_GRID;
        break;
      case StorageName.FORMNAME_TRANSACTION_INCOMEINVOICE:
        this.storageName = StorageName.TRANSACTION_INCOMEINVOICE_PAYMENTLIST_GRID;
        break;
    }
  }


  agGridDataModelRecieptVoucher: AgGridI = {
    colDefs: ColDefsPaymentVoucherList,
    rowSelection: "multiple",
    storageName: StorageName.TRANSACTION_PAYMENT_LIST_RECEIPTVOUCHER_GRID,
    filterStorageName: StorageName.FILTER_TRANSACTION_PAYMENT_LIST_RECEIPTVOUCHER_GRID,
    sortStorageName: StorageName.SORT_TRANSACTION_PAYMENT_LIST_RECEIPTVOUCHER_GRID,
    paginationStorageName: StorageName.PAGINATION_TRANSACTION_PAYMENT_LIST_RECEIPTVOUCHER_GRID,
    rows: [],
    isFilter: true,
    isServerSidepagination: true,
    showPagination: true,
  };
  agGridDataModelPaymentVoucher: AgGridI = {
    colDefs: ColDefsPaymentVoucherList,
    rowSelection: "multiple",
    storageName: StorageName.TRANSACTION_PAYMENT_LIST_PAYMENTVOUCHER_GRID,
    filterStorageName: StorageName.FILTER_TRANSACTION_PAYMENT_LIST_PAYMENTVOUCHER_GRID,
    sortStorageName: StorageName.SORT_TRANSACTION_PAYMENT_LIST_PAYMENTVOUCHER_GRID,
    paginationStorageName: StorageName.PAGINATION_TRANSACTION_PAYMENT_LIST_PAYMENTVOUCHER_GRID,
    rows: [],
    isFilter: true,
    isServerSidepagination: true,
    showPagination: true,
  };
  agGridDataModelMaterialIn: AgGridI = {
    colDefs: ColDefsPaymentVoucherList.filter(col => !colKeyNames.includes(col)),
    rowSelection: "multiple",
    storageName: StorageName.TRANSACTION_PAYMENT_LIST_MATERIALIN_GRID,
    filterStorageName: StorageName.FILTER_TRANSACTION_PAYMENT_LIST_MATERIALIN_GRID,
    sortStorageName: StorageName.SORT_TRANSACTION_PAYMENT_LIST_MATERIALIN_GRID,
    paginationStorageName: StorageName.PAGINATION_TRANSACTION_PAYMENT_LIST_MATERIALIN_GRID,
    rows: [],
    isFilter: true,
    isServerSidepagination: true,
    showPagination: true,
  };
  agGridDataModelMaterialOut: AgGridI = {
    colDefs: ColDefsPaymentVoucherList.filter(col => !colKeyNames.includes(col)),
    rowSelection: "multiple",
    storageName: StorageName.TRANSACTION_PAYMENT_LIST_MATERIALOUT_GRID,
    filterStorageName: StorageName.FILTER_TRANSACTION_PAYMENT_LIST_MATERIALOUT_GRID,
    sortStorageName: StorageName.SORT_TRANSACTION_PAYMENT_LIST_MATERIALOUT_GRID,
    paginationStorageName: StorageName.PAGINATION_TRANSACTION_PAYMENT_LIST_MATERIALOUT_GRID,
    rows: [],
    isFilter: true,
    isServerSidepagination: true,
    showPagination: true,
  };
  agGridDataModelExpenses: AgGridI = {
    colDefs: ColDefsPayment,
    rowSelection: "multiple",
    storageName: StorageName.TRANSACTION_PAYMENT_LIST_EXPENSES_GRID,
    filterStorageName: StorageName.FILTER_TRANSACTION_PAYMENT_LIST_EXPENSES_GRID,
    sortStorageName: StorageName.SORT_TRANSACTION_PAYMENT_LIST_EXPENSES_GRID,
    paginationStorageName: StorageName.PAGINATION_TRANSACTION_PAYMENT_LIST_EXPENSES_GRID,
    rows: [],
    isFilter: true,
    isServerSidepagination: true,
    showPagination: true,
  };
  agGridDataModelIncome: AgGridI = {
    colDefs: ColDefsPayment,
    rowSelection: "multiple",
    storageName: StorageName.TRANSACTION_PAYMENT_LIST_INCOMEINCOME_GRID,
    filterStorageName: StorageName.FILTER_TRANSACTION_PAYMENT_LIST_INCOME_GRID,
    sortStorageName: StorageName.SORT_TRANSACTION_PAYMENT_LIST_INCOME_GRID,
    paginationStorageName: StorageName.PAGINATION_TRANSACTION_PAYMENT_LIST_INCOME_GRID,
    rows: [],
    isFilter: true,
    isServerSidepagination: true,
    showPagination: true,
  };
}

// For Removing Specific columns fron Payment List Grid --
export const colKeyNames = [SalesPersonColumn];

export const PaymentVoucherTypes = {
  ReceiptVoucher : 'ReceiptVoucher',
  PaymentVoucher : 'PaymentVoucher',
  MaterialIn     :  'MaterialIn',
  MaterialOut    :  'MaterialOut',
  Expense        :  'Expense',
  income         :  'income',
}
